import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function Contact() {
  const { identity } = portfolio;
  const cards = [
    { icon: "mail", label: "Email", value: identity.email, href: "mailto:" + identity.email, download: false },
    { icon: "code", label: "GitHub", value: "github.com/" + identity.handle, href: identity.links.github, download: false },
    { icon: "groups", label: "LinkedIn", value: "in/grmk", href: identity.links.linkedin, download: false },
    { icon: "open_in_new", label: "Résumé", value: "PDF · A4", href: identity.links.cv, download: false },
  ];

  return (
    <section id="contact" className="md-section">
      <div className="md-container">
        <SectionHead
          num="11"
          eyebrow="Contact"
          title="Let's talk."
          dek="Open to research, internships, full-time, and the occasional speaking slot."
        />

        <div className="m3-contact__grid">
          {cards.map((c) => (
            <a
              key={c.label}
              href={c.href}
              {...(c.download ? { download: true } : { target: "_blank", rel: "noreferrer" })}
              className="md-card md-card--filled md-card--interactive m3-contact-card"
            >
              <div className="m3-contact-card__icon">
                <span className="material-symbols-rounded">{c.icon}</span>
              </div>
              <div>
                <div className="md-label-m m3-contact-card__label">{c.label}</div>
                <div className="md-title-m m3-contact-card__value">{c.value}</div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "auto" }}>
                <span className="material-symbols-rounded icon-20 dim">arrow_outward</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
